import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router';

export const InvitesRouting = allProps => {
  return (
    <Switch>
      <Route exact path={'/invites/archive'} render={() => <Redirect to="/tournaments/invites/archive" />} />
      <Route render={() => <Redirect to="/tournaments/invites/outbox" />} />
    </Switch>
  );
};

InvitesRouting.displayName = 'InvitesRouting';
